import { createAction, props } from '@ngrx/store';
import { StepItems } from 'src/app/shared/components/stepper/stepper.component';

const ONBOARDING_KEY = '[Onboarding]';

export const InitSteps = createAction(
  `${ONBOARDING_KEY} init steps`
);

export const CheckServerSteps = createAction(
  `${ONBOARDING_KEY} check server steps`
);

export const SetSteps = createAction(
  `${ONBOARDING_KEY} set steps`,
  props<{ steps: StepItems [], currentStep: number }>()
);

export const SetCurrentStep = createAction(
  `${ONBOARDING_KEY} set current step`,
  props<{ currentStep: number }>()
);

export const GetGeneralInfo = createAction(
  `${ONBOARDING_KEY} get general info`
);

export const GetGeneralInfoSuccess = createAction(
  `${ONBOARDING_KEY} get general info success`,
  props<{ role: string, payload: any }>()
);

export const GetGeneralInfoFailure = createAction(
  `${ONBOARDING_KEY} get general info failure`,
  props<{ err: any }>()
);

export const SetGeneralInfo = createAction(
  `${ONBOARDING_KEY} set general info`,
  props<{ section: string, data: any }>()
);

export const StepValid = createAction(
  `${ONBOARDING_KEY} step valid`,
  props<{ section: string, key: string, data: any }>()
);

export const StepValidSaved = createAction(
  `${ONBOARDING_KEY} step valid saved`,
  props<{ section: string, key: string, data: any }>()
);

export const SetHardSkills = createAction(
  `${ONBOARDING_KEY} set hard skills`,
  props<{ skillsList: any[], noServer?: boolean }>()
);

export const GetHardSkills = createAction(
  `${ONBOARDING_KEY} get hard skills`
);

export const GetHardSkillsSuccess = createAction(
  `${ONBOARDING_KEY} get hard skills success`,
  props<{ skillsList: any[] }>()
);

export const GetHardSkillsFailure = createAction(
  `${ONBOARDING_KEY} get hard skills failure`,
  props<{ err: any }>()
);

export const GetSoftSkills = createAction(
  `${ONBOARDING_KEY} get soft skills`
);

export const GetSoftSkillsSuccess = createAction(
  `${ONBOARDING_KEY} get soft skills success`,
  props<{ skillsList: any[] }>()
);

export const GetSoftSkillsFailure = createAction(
  `${ONBOARDING_KEY} get soft skills failure`,
  props<{ err: any }>()
);

export const SetSoftSkills = createAction(
  `${ONBOARDING_KEY} set soft skills`,
  props<{ skillsList: any[] }>()
);

export const SetSoftSkillsSuccess = createAction(
  `${ONBOARDING_KEY} set soft skills success`
);

export const GetJobTitles = createAction(
  `${ONBOARDING_KEY} get job titles`
);

export const GetJobTitlesSuccess = createAction(
  `${ONBOARDING_KEY} get job titles success`,
  props<{ jobTitles: any[] }>()
);

export const GetJobTitlesFailure = createAction(
  `${ONBOARDING_KEY} get job titles failure`,
  props<{ err: any }>()
);

export const GetSkillsList = createAction(
  `${ONBOARDING_KEY} get skills list`
);

export const GetSkillsListSuccess = createAction(
  `${ONBOARDING_KEY} get skills list success`,
  props<{ skillsList: any[] }>()
);

export const GetSkillsListFailure = createAction(
  `${ONBOARDING_KEY} get skills list failure`,
  props<{ err: any }>()
);

export const SetTalentSeniority = createAction(
  `${ONBOARDING_KEY} set talent seniority`,
  props<{ level: string }>()
);

export const SetTalentSenioritySuccess = createAction(
  `${ONBOARDING_KEY} set talent seniority success`,
  props<{ level: string }>()
);

export const SetTalentSeniorityFailure = createAction(
  `${ONBOARDING_KEY} set talent seniority failure`
);